import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private apiService: APIService
  ) {}

  /**
   * Service for list all users
   *
   * @param {Object} urlParams
   */
  getAll(urlParams: Object): Observable<any> {
    return this.apiService
      .post('/srv/user/listusers', urlParams);
  }

  /**
   * Service for get user by session
   *
   * @param {Object} urlParams
   */
  get(urlParams?: Object): Observable<any> {
    return this.apiService
      .post('/srv/user/getuser', urlParams);
  }

  /**
   * Service for create user
   *
   * @param {Object} urlParams
   */
  create(urlParams: Object): Observable<any> {
    return this.apiService
      .post('/srv/user/adduser', urlParams);
  }

  /**
   * Service for update
   *
   * @param {Object} urlParams
   */
  update(urlParams: Object): Observable<any> {
    return this.apiService
      .post('/srv/user/updateuser', urlParams);
  }

  /**
   * Service for delete user
   *
   * @param {Object} urlParams
   */
  delete(urlParams: Object): Observable<any> {
    return this.apiService
      .post('/srv/user/deluser', urlParams);
  }
}
